import * as React from 'react';
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import { setCurrentUserAction } from '../../../store/user/actions';
import { connect, useSelector } from 'react-redux';
import { getUserState } from '../../../store/user/selectors';
import RequestMail from './RequestMail/RequestMail';

interface DispathProps {
	setCurrentUserAction: typeof setCurrentUserAction;
}

const SuccessAuth: React.FunctionComponent<DispathProps> = props => {
	const token = new URLSearchParams(useLocation().search).get('token') || '',
		[canRedirect, setRedirect] = React.useState(false),
		[suggestEmail, setSuggestEmail] = React.useState(false);
	
	const history = useHistory();
	
	const userProfile = useSelector(getUserState);

	React.useEffect(() => {
		if (userProfile.userId > 0) {
			if (userProfile.userId > 0 && userProfile.user.id > 0 && !userProfile.user.email) {
				const skipEmail = localStorage.getItem("skipEmail");

				if (!skipEmail) {
					setSuggestEmail(true);
				}
				else {
					window.location.href = "/books";
				}
			}
			else {
				window.location.href = "/books";
			}
		}
	}, [userProfile]);

	const onClose = (success?: boolean) => {
		if (!success) {
			localStorage.setItem("skipEmail", "true");
		}

		setSuggestEmail(false);
		setRedirect(true);
	};

	return <>
		{canRedirect && <Redirect to="/books" />}

		{suggestEmail && <RequestMail onClose={onClose}/>}
	</>;
};

export default connect(null, {
	setCurrentUserAction
})(SuccessAuth);
